import PropTypes from 'prop-types';

import ArticleCard from '../ArticleCard';
import { Carousel } from './Carousel';
import CarouselSlide from './CarouselSlide';

/**
 * ArticleCarousel component for displaying articles in a carousel format
 * @param {object} props - Component props
 * @param {Array} props.items - Array of article objects to display
 * @param {number} props.autoplayDurationInSeconds - Autoplay duration in seconds
 * @param {Function} props.onArticleClick - Callback when an article is clicked
 * @param {Function} props.onComponentClick - Callback when a component is clicked
 * @returns {ReactElement} The ArticleCarousel component
 */

function ArticleCarousel({
  // articles = [],
  autoplayDurationInSeconds = 15,
  onArticleClick,
  onComponentClick,
  items = []
}) {
  const articles = items;
  if (!articles || articles.length === 0) {
    return null;
  }

  const handleArticleClick = (articleProps) => {
    if (onArticleClick) {
      onArticleClick(articleProps);
    }
  };

  return (
    <Carousel autoplayDurationInSeconds={autoplayDurationInSeconds} totalSlides={articles.length}>
      {articles.map((item, index) => {
        // Handle both direct props and componentType structure from GraphQL
        const articleProps =
          item.componentType === 'ArticleCard' ? { ...item.props, onComponentClick } : {};

        return (
          <CarouselSlide
            key={item.id || `article-${index}`}
            slideIndex={index + 1}
            totalSlides={articles.length}
          >
            <ArticleCard {...articleProps} onClick={() => handleArticleClick(articleProps)} />
          </CarouselSlide>
        );
      })}
    </Carousel>
  );
}

ArticleCarousel.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.oneOfType([
      // Direct article props
      PropTypes.shape({
        id: PropTypes.string,
        title: PropTypes.string,
        description: PropTypes.string,
        imageUrl: PropTypes.string,
        featured: PropTypes.bool,
        onClick: PropTypes.func
      }),
      // Component structure from GraphQL
      PropTypes.shape({
        componentType: PropTypes.string,
        props: PropTypes.object
      })
    ])
  ),
  autoplayDurationInSeconds: PropTypes.number,
  onArticleClick: PropTypes.func,
  onComponentClick: PropTypes.func
};

export default ArticleCarousel;
